"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityContactMapDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class OpportunityContactMapDto {
    constructor(contactId) {
        this.contactId = contactId;
    }
}
exports.OpportunityContactMapDto = OpportunityContactMapDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the associated contact",
        example: 202,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Contact ID is required" }),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a valid integer" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityContactMapDto.prototype, "contactId", void 0);
